import { PublicHomeResponse } from '@ahora-patagonia/contracts';
import type { ApiClient } from '../../../shared/http/ApiClient.js';
import { fixtureHome, fixturesActivos } from '../../../shared/fixtures/publicFixtures.js';
import type { HomeData } from '../entities/HomeData.js';

/**
 * Acceso a la home pública. El response se valida con el schema de contracts: si la API y
 * el sitio divergen, falla acá (rápido y con nombre) y no en un render roto.
 *
 * Con `VITE_PUBLIC_FIXTURES` seteado devuelve datos de muestra — es lo que permite la
 * matriz de verificación (5/7/9 bloques × estados) sin API ni seed.
 */
export class HomeRepository {
  constructor(private readonly api: ApiClient) {}

  async home(): Promise<HomeData> {
    const fixtures = fixturesActivos();
    if (fixtures) return fixtureHome(fixtures);
    const data = await this.api.get<unknown>('/public/home');
    return PublicHomeResponse.parse(data);
  }
}
